import { MapPin } from "lucide-react";
import { Reveal, Kicker } from "./Reveal";
import { ADDRESS, MAPS_EMBED } from "../../data/site";

export const Location = () => {
    return (
        <section
            id="locatie"
            data-testid="location-section"
            className="relative bg-black py-24 text-white md:py-36"
        >
            <div className="mx-auto max-w-7xl px-6 md:px-12">
                <div className="mb-12 flex flex-col justify-between gap-6 md:flex-row md:items-end">
                    <div>
                        <Reveal>
                            <Kicker>Locație</Kicker>
                        </Reveal>
                        <Reveal delay={0.05}>
                            <h2 className="mt-6 font-display text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
                                Ne găsești <span className="text-gold">aici</span>
                            </h2>
                        </Reveal>
                    </div>
                    <Reveal delay={0.1}>
                        <div className="flex items-start gap-3 text-neutral-300">
                            <MapPin size={20} className="mt-0.5 text-gold" strokeWidth={1.5} />
                            <span data-testid="location-address" className="font-body">
                                {ADDRESS}
                            </span>
                        </div>
                    </Reveal>
                </div>

                <Reveal delay={0.1}>
                    <div className="overflow-hidden rounded-2xl border border-white/10">
                        <iframe
                            title="Harta GAN BARBERSHOP"
                            data-testid="location-map"
                            src={MAPS_EMBED}
                            className="map-frame h-[380px] w-full md:h-[520px]"
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            allowFullScreen
                        />
                    </div>
                </Reveal>
            </div>
        </section>
    );
};
